import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

/**
 * 通知规则列表（规则的 notifyCategory 与 `/common/enum/options?key=NotifyCategory` 同一套编码）
 * GET /notification/rule
 */
export function getNotificationRules (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/notification/rule`, {
    params: { ...query, axiosType: 'java' }
  })
}

/**
 * 短信模版变量 key 选项（与规则 notifyCategory 一致）
 * GET /common/notification/{category}/template_var_keys
 */
export function getNotificationTemplateVarKeys (category) {
  const c = encodeURIComponent(String(category))
  return Api.get(
    `${BasicConfig.jDomain}/common/notification/${c}/template_var_keys`,
    {
      params: { axiosType: 'java' }
    }
  )
}

/**
 * 新建通知规则 POST /notification/rule
 */
export function createNotificationRule (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/notification/rule`, {
    ...body,
    axiosType: 'javaJson'
  })
}

/**
 * 更新通知规则 PUT /notification/rule/{id}
 */
export function updateNotificationRule (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/notification/rule/${id}`, {
    ...body,
    axiosType: 'javaJson'
  })
}

/**
 * 删除通知规则 DELETE /notification/rule/{id}
 */
export function deleteNotificationRule (id) {
  return Api.delete(`${BasicConfig.jDomain}/notification/rule/${id}`, {
    params: { axiosType: 'java' }
  })
}

/**
 * 拷贝通知规则到其他门店 POST /notification/rule/{id}/copy
 * @param {string|number} id 规则 id
 * @param {{ targetStoreIds: number[], overwrite?: boolean }} body
 */
export function copyNotificationRule (id, body = {}) {
  return Api.post(`${BasicConfig.jDomain}/notification/rule/${id}/copy`, {
    ...body,
    axiosType: 'javaJson'
  })
}

/**
 * 创蓝短信模板选项
 * GET /chuanglan/template/options
 * 响应项：{ label, value, desc }
 */
export function getChuanglanTemplateOptions (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/chuanglan/template/options`, {
    params: { ...query, axiosType: 'java' }
  })
}
